import Typography from "@mui/material/Typography";
import BoxContent from "shared/ui/BoxContent";
import CustomDatePicker from "../../../../shared/form/CustomDatePicker";

const TestStartDate = ({ startDate, errors, handleTestStartDate, classroomId = null, classroomName = "" }: any) => {

    return (
        <>
            <Typography variant={classroomName !== "" ? "h2" :"h3"} mt={3} mb={3}>
                Completează în câmpul de mai jos data și ora la care elevul/elevii {classroomName !== "" ? "din clasa " + classroomName : ""} pot accesa sesiunea de testare generată.
            </Typography>
            {classroomName !== "" ? (
                <>
                    <CustomDatePicker
                        name={`test_start_date_${classroomId}`}
                        startDate={startDate}
                        // defaultValue={startDate}
                        onDateChange={(date) => handleTestStartDate(date, classroomId)}
                        type="controlledDatePicker"
                        errorMessage={errors.start_date?.message}
                        error={!!errors.start_date?.message}
                        showTimeSelect={true}
                    />
                    <Typography variant="body1" mb={3}></Typography>
                </>
            ) : (
                <BoxContent zIndex={10}>
                    <CustomDatePicker
                        name="test_start_date"
                        startDate={startDate}
                        // defaultValue={startDate}
                        onDateChange={(date) => handleTestStartDate(date)}
                        type="controlledDatePicker"
                        errorMessage={errors.start_date?.message}
                        error={!!errors.start_date?.message}
                        showTimeSelect={true}
                    />
                    <Typography variant="body1" mb={3}></Typography>
                </BoxContent>
            )}

        </>
    );
};

export default TestStartDate;
